import {
  VIDEOS_LOADER,
  DOWNLOAD_COUNT,
  SET_VIDEOS_DATA,
  SET_VIDEO_DETAIL_DATA,
} from "../actionTypes";

const initialState = {
  loader: false,
  videoDetail: {},
  videos: {},
};

const videosReducer = (state = initialState, action) => {
  switch (action.type) {
    case VIDEOS_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_VIDEOS_DATA: {
      return {
        ...state,
        videos: action.payload,
      };
    }
    case SET_VIDEO_DETAIL_DATA: {
      return {
        ...state,
        videoDetail: action.payload,
      };
    }
    case DOWNLOAD_COUNT: {
      if (action.payload == "fileview") {
        return {
          ...state,
          videoDetail: {
            ...state.videoDetail,
            fileViewCount: (state.videoDetail?.fileViewCount || 0) + 1,
          },
        };
      } else
        return {
          ...state,
          videoDetail: {
            ...state.videoDetail,
            downloadCount: (state.videoDetail?.downloadCount || 0) + 1,
          },
        };
    }
    default:
      return state;
  }
};

export default videosReducer;
